module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_home_color_green-5a82037605efa7abb1dd7bec64219385.svg";